module.exports = __webpack_public_path__ + "img/logo_color.9ac53711.png";